<template>
  <div>
    <div class="sup_switch">
      <a href="" @click.prevent="openAddPopup('#Popup__formAdd1')" class="click_needs_analysis_tuneSpent"><i class="fas fa-sliders-h"></i> 調整花費</a>
    </div>
    <div class="CommonPopup sup_switch--modal" id="Popup__formAdd1">
      <div class="Popup__overlay"></div>
      <div class="Popup__box">
        <div class="Popup__content">
          <div class="Popup__title">
            <h3>調整退休花費</h3>
          </div>
          <div class="Popup__paragraph">
            <div class="sup_switch--bars retiremod">
              <div class="bars_text">
                <h4>旅遊花費</h4>
                <p>{{ travelVal  | currency }} <span>元／月</span></p>
              </div>
              <div class="bars">
                <input class="slider" id="travel" type="range" min="1000" max="200000" step="1000" v-model="travelVal">
              </div>
            </div>
            <div class="sup_switch--bars retiremod">
              <div class="bars_text">
                <h4>飲食花費</h4>
                <p>{{ foodVal | currency }} <span>元／月</span></p>
              </div>
              <div class="bars">
                <input class="slider" id="food" type="range" min="1000" max="50000" step="1000" v-model="foodVal">
              </div>
            </div>
            <div class="sup_switch--bars retiremod">
              <div class="bars_text">
                <h4>交通花費</h4>
                <p>{{ transVal  | currency }} <span>元／月</span></p>
              </div>
              <div class="bars">
                <input class="slider" id="trans" type="range" min="1000" max="50000" step="1000" v-model="transVal">
              </div>
            </div>
            <div class="sup_switch--bars retiremod">
              <div class="bars_text">
                <h4>休閒花費</h4>
                <p>{{ normalVal | currency }} <span>元／月</span></p>
              </div>
              <div class="bars">
                <input class="slider" id="normal" type="range" min="1000" max="20000" step="1000" v-model="normalVal">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-6 col-md-6 form-group" @click.prevent="closeAddPopup('#Popup__formAdd1')">
              <div class="share_btn share_btn_blue"><a href="">取消</a>
              </div>
            </div>
            <div class="col-xs-6 col-md-6 form-group" @click.prevent="confirm('#Popup__formAdd1')">
              <div class="share_btn share_btn_blueDefault "><a class="click_needs_analysis_tuneSpent_done" href="">確定</a>
              </div>
            </div>
          </div>

          <div class="Popup__close" @click="closeAddPopup('#Popup__formAdd1')">
            <i class="fas fa-times"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>


export default {
  name: "month_cost",
  props: {
    travel: Number,
    trans: Number,
    food: Number,
    normal: Number,
  },
  data: function () {
    return {
      travelVal: this.travel,
      transVal: this.trans,
      foodVal: this.food,
      normalVal: this.normal,
    }
  },
  methods: {
    openAddPopup(id) {
      $(id).fadeIn(500)
    },
    closeAddPopup(id) {
      this.setBarDefault()
      this.setBarRange()
      $(id).fadeOut(500)
    },
    confirm(id) {
      let travelVal = parseInt($('#travel').val())
      let translVal = parseInt($('#trans').val())
      let foodlVal = parseInt($('#food').val())
      let normalVal = parseInt($('#normal').val())
      let monthTotalCost = {
        travel: travelVal,
        trans: translVal,
        food: foodlVal,
        normal: normalVal
      }
      this.$emit('updateResult', monthTotalCost)
      $(id).fadeOut(500)
    },
    setBarDefault() {
      this.travelVal = this.travel
      this.transVal = this.trans
      this.foodVal = this.food
      this.normalVal = this.normal
    },
    setBarRange() {
      $(function () {
        let barList = ['travel', 'trans', 'food', 'normal']
      barList.forEach(item => {
        var r = $(`#${item}`);
        let max = parseInt(r[0].attributes.max.nodeValue)
        let min = parseInt(r[0].attributes.min.nodeValue)
        bg(r.val(), max, min);
        r.on('mouseenter', function () {
          var p = r.val();
          r.on('click', function () {
            p = r.val();
            bg(p, max, min);
          });
          r.on('mousemove', function () {
            p = r.val();
            bg(p, max, min);
          });
        });

        r.on('touchstart', function () {
          var p = r.val();
          r.on('click', function () {
            p = r.val();
          });
          r.on('touchmove', function () {
            p = r.val();
            bg(p, max, min);
          });
          r.on('touchend', function () {
            p = r.val();
            bg(p, max, min);
          });
        });

        function bg(n, max, min) {
          let v = (Number.parseInt(n) - min)*100 / (max - min)
          r.css({
            'background-image': '-webkit-linear-gradient(left ,#62C4D3 0%,#62C4D3 ' + v + '%,#f2f2f2 ' + v + '%, #f2f2f2 100%)'
          });
        }
      })

      });
    }
  },
  filters: {
    currency(value) {
      var num = (value || 0).toString(), result = '';
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      if (!result.indexOf('-,')) result = result.replace('-,', '-')
      return result;
    },
  },
  created() {
    this.setBarRange()
    setTimeout(() => {
      this.setBarDefault()
      this.setBarRange()
    }, 3000)
  },

}
</script>

<style scoped>

</style>